module.exports = __webpack_public_path__ + "img/161.b81b50ff.png";